import { Directive, ElementRef, HostListener } from '@angular/core';

// tslint:disable-next-line:directive-selector
@Directive({ selector: '[postal]' })
export class PostalCodeDirective {
  constructor(private el: ElementRef) { }



  @HostListener('keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {

    let num = new RegExp("^[0-9]$");
    let alpha = new RegExp("^[A-Z]$");
    const input = event.target as HTMLInputElement;
    let str = input.value.replace(/\s+/g, '').toUpperCase();

    let pos = str.length - 1;
    if (str.length % 2 == 0) {
      if (!num.test(str.substr(pos, 1))) {
        str = str.slice(0,pos);
      }
    } else if (!alpha.test(str.substr(pos, 1))) {
      str = str.slice(0,pos);
    }

    const parts = [str.substr(0, 3)];

    if (str.length > 3) {
      parts.push(str.substr(3, 3));
    }
    input.value = parts.join(' ');
  }
}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/shared/directives/postal-code/postal-code.directive.ts